export default __webpack_public_path__ + "static/media/cmt.3752df78.svg";